module.exports = "/_next/static/media/cb88a3f7a9f448e983b58b6bdc7b1896.svg";